const config = {
  env: "local",



   apiUrl: "https://api.eskocast.com/admin",

  shipRocketApiUrl: "https://apiv2.shiprocket.in/v1/external/",
};

export default config;
